export default __webpack_public_path__ + "3d836ea0c2480ab12b4b97ccc5259e7d.woff2";